import axios from 'axios'
import Geohash from 'latlon-geohash'

const geonames = 'https://secure.geonames.org/'

export const getName = (latlng, maxRows = 1, lang = 'en') => {
  let url = geonames + 'findNearbyJSON'
  url += '?lat=' + latlng[0]
  url += '&lng=' + latlng[1]
  url += '&username=' + process.env.VUE_APP_GEONAMES
  url += '&lang=' + lang
  url += '&maxRows=' + maxRows
  return axios.get(url)
}

export const getLocationsUrl = (term, maxRows = 10, lang = 'en') => {
  let url = geonames + 'searchJSON'
  url += '?q=' + encodeURIComponent(term)
  url += '&lang=' + lang
  url += '&username=' + process.env.VUE_APP_GEONAMES
  url += '&maxRows=' + maxRows
  return url
}

export const getLocations = (term, lang = 'en', maxRows = 100) => {
  const url = getLocationsUrl(term, maxRows, lang)
  return new Promise((resolve, reject) => {
    axios.get(url).then(res => {
      const places = res.data.geonames ? res.data.geonames.map(geoname => {
        const lat = Number(geoname.lat)
        const lng = Number(geoname.lng)
        const hash = Geohash.encode(lat, lng, 4)
        return {
          name: geoname.name,
          coords: [lat, lng],
          place: geoname.adminName1,
          country: geoname.countryName,
          flag: geoname.countryCode ? geoname.countryCode.toLowerCase() : '',
          hash
        }
      }).reduce((places, p) => { // The "joinville le pont" paradox, make sure places are not duplicated
        const place = places.find(ep => ep.hash === p.hash && ep.name.substring(0, 20) === p.name.substring(0, 20))
        if (!place) places.push(p)
        return places
      }, []) : []
      // .map(place => {
      //   return {
      //     name: place.name,
      //     country: place.country
      //   }
      // })
      resolve(places)
    }).catch(err => reject(err))
  })
}
